import {
  FilterMode,
  SatelliteMachineCreateMutationVariables,
  SatelliteMachine_OrderBy,
  SatelliteMachine,
  SortOrder,
  SatelliteMachine_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const satelliteMachineService = {
  createOne: buildCreateOne(
    (
        satelliteMachineCreateVariables: SatelliteMachineCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.satelliteMachineCreate(
          satelliteMachineCreateVariables
        );
        return result.satelliteMachineCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.satelliteMachineOne({ id });
    return result.satelliteMachineOne as SatelliteMachine;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SatelliteMachine_OrderBy[] | null = null,
    filter: SatelliteMachine_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SatelliteMachine_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            machineCode: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
          { location: { contains: searchValue, mode: FilterMode.Insensitive } },
          { region: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.satelliteMachineListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [
            { name: SortOrder.Asc },
            { machineCode: SortOrder.Asc },
            { location: SortOrder.Asc },
            { region: SortOrder.Asc },
          ],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.satelliteMachineListWithOffset
    ) as SatelliteMachine[];
    return { list, orderBy };
  },
};
